import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import LoginView from '../views/LoginView.vue';
import LogoutView from '../views/LogoutView.vue';
import RefreshView from '../views/RefreshView.vue';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }],
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutView,
    meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }],
  },
  {
    path: '/refresh',
    name: 'refresh',
    component: RefreshView,
    meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
});

// 需要登入的頁面先確認登入狀態，未登入直接轉導至登入頁，不先顯示頁面
router.beforeEach(async (to, from, next) => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next();
    return;
  }
  // App 內嵌時由網址帶入 token，交給頁面處理
  if (to.query.at) {
    next();
    return;
  }
  // 首次導航早於 App.vue 的 created，需先初始化 oidc
  store.dispatch('initialOidc');
  const isLogin = await store.dispatch('restoreUser');
  if (isLogin) {
    next();
    return;
  }
  store.dispatch('loginRedirectUnityPage');
  next(false);
});

export default router;
